import React, {Component} from 'react';
import {connect} from 'react-redux';
import Quote from '../../components/Quote/quote';
import {
  changeBrokerCommission,
  changeQuoteClientDetailsForm,
  changeQuoteRequired,
  changeQuoteState,
  copyQuote,
  createQuote,
  getQuoteById,
  getQuoteDefaultSettings,
  getQuoteIPT,
  getQuoteMessages,
  getQuotePolicyOverview,
  getQuoteProposalForms,
  getQuoteQuestions,
  getQuoteScheduleInfo,
  getQuoteSchedulesMessage,
  getQuoteStatuses,
  handleQuoteProductsChange,
  resetQuoteOptions,
  resetQuoteState,
  sendQuoteScheduleViaEmail,
  updateQuote,
  getQuoteMinimumPricing,
  getQuotePolicyWordings,
  getQuotePointsOfSale,
} from '../../actions/quote';
import _ from 'lodash';
import moment from 'moment';
import {getBrokerById} from '../../actions/broker';
import {getBrokers} from '../../actions/brokers';
import {_getFileFromBase64, isAgent, isAragUser} from '../../helpers/functions';
import {ARAG_POLICY_TYPE} from '../../helpers/variables';

class QuoteHOC extends Component {
    componentDidMount(){
        this.props.getQuoteQuestions();
        this.props.getQuoteStatuses();
        this.props.getQuoteIPT();
        this.props.getQuoteMessages();
        this.props.getQuotePolicyOverview();
        this.props.getQuoteSchedulesMessage();
        this.props.getQuoteMinimumPricing();
        //if user is an arag user get all brokers for the step 1
        if(isAragUser(this.props.loggedInUserRoles)){
            this.props.getBrokers({offset:0})
        }

        //if the user is an arag user and an existing quote is loaded fetch the broker by the quote agents id
        if(
            isAragUser(this.props.loggedInUserRoles)
            && this.props.quote.id
        ) {
            this.props.getBrokerById({id: this.props.quote.applicationUserId});
        }

        //if the user is an agent fetch his info using his id
        if(isAgent(this.props.loggedInUserRoles)){
            this.props.getBrokerById({id: this.props.loggedInUserId});
        }

        if(this.props.match.params.id){
            this.props.getQuoteById({id: this.props.match.params.id})
        }
    }
    _changeToNextStep = () => {
        if(this.props.wizardStep < 4){
            this.props.changeQuoteState({key: 'wizardStep', value: this.props.wizardStep + 1})
        }
    };
    componentWillReceiveProps(nextProps){
        //if proposal form is fetched download it
        if (
          this.props.fetchingQuoteProposalForm &&
          !nextProps.fetchingQuoteProposalForm &&
          nextProps.quoteProposalForm.id
        ) {
          _getFileFromBase64(nextProps.quoteProposalForm);
        }

        if (
          this.props.fetchingQuotePolicyWording &&
          !nextProps.fetchingQuotePolicyWording &&
          nextProps.quotePolicyWording.id
        ) {
          _getFileFromBase64(nextProps.quotePolicyWording);
        }

        if (
          this.props.fetchingQuotePointOfSale &&
          !nextProps.fetchingQuotePointOfSale &&
          nextProps.quotePointOfSale.id
        ) {
          _getFileFromBase64(nextProps.quotePointOfSale);
        }

        //if the user is an arag user and an existing quote is loaded fetch the broker by the quote agents id
        if(
            isAragUser(this.props.loggedInUserRoles)
            && !this.props.quote.id && nextProps.quote.id
        ) {
            this.props.getBrokerById({id: nextProps.quote.applicationUserId});
        }
    }

    _changeToPreviousStep = () => {
        if(this.props.wizardStep > 0){
            this.props.changeQuoteState({key: 'wizardStep', value: this.props.wizardStep - 1})
        }
    };

    _findResetIds = (question, answer) => {
        let ids = [];
        _.forEach(question.options, o => {
            if(o.id.toString() !== answer.toString()){
                _.forEach(o.childQuestions, cq => {
                    cq = this._findQuestion(cq.id);
                    ids.push(cq.id);
                    ids =  [...ids, ...this._findResetIds(cq, answer)]
                });
            }
        });
        return ids;
    };

    _findQuestion = (questionId) => {
        return _.find(this.props.quoteQuestions, question => {return question.id.toString() === questionId.toString()})
    };

    _calculateFormData = (changedFieldId, changedFieldValue) => {
        let triggeredQuestion = this._findQuestion(changedFieldId);
        if(!triggeredQuestion) return {...this.props.clientDetailsForm};
        let idsToReset = this._findResetIds(triggeredQuestion, changedFieldValue);
        return _.mapValues(this.props.clientDetailsForm, (data, key) => {
            return idsToReset.includes(parseInt(key))?'':data;
        });
    };

    handleSelectChange = (evt) => {
        this.props.changeQuoteState({
            key: 'clientDetailsForm', value: this._calculateFormData(evt.target.name, evt.target.value)
        });
        this.props.changeQuoteClientDetailsForm({key: evt.target.name, value: evt.target.value});
    };

    _getQuestionAnswer = (questionMachineName) => {
        const question =  _.find(this.props.quoteQuestions, q => q.machineName === questionMachineName);
        if(!question) return '';
        const formAnswer = this.props.clientDetailsForm[question.id];
        if(question.inputType === 'drop down'){
            const option = _.find(question.options, option => {return option.id.toString() === formAnswer.toString()});
            if(!option) {return ''}
            return option.name
        } else {
            return formAnswer
        }
    };

    _handleClientDetailsFormSubmit = (evt) => {
        evt.preventDefault();
        let sendBody = {
            applicationAnswersDtos: _.map(this.props.clientDetailsForm, (answer, key) => {
                return this._getAnswerDto(key, answer)
            })
        };
        if(isAragUser(this.props.loggedInUserRoles)) {
            sendBody.agentsId = this.props.selectedBroker
        }

        this.props.createQuote({
            sendBody: sendBody,
        });
    };

    _getAnswerDto = (questionId, answer) => {
        const question = this.props.quoteQuestions.find(question => {
            return question.id.toString() === questionId.toString()
        });
        if(question.inputType === 'text' || question.inputType === 'text area'){
            return {
                questionId: questionId,
                optionId: null,
                text: answer,
                amount: null,
                questionMachineName: question.machineName
            }
        }
        if(question.inputType === 'amount'){
            if(question.machineName === 'AnnualTurnover' && !answer){
                answer = 0;
            }

            return {
                questionId: questionId,
                optionId: null,
                text: null,
                amount: answer,
                questionMachineName: question.machineName
            }
        }
        if(question.inputType === 'drop down'){
            const option = question.options.find(option => {
                return option.id.toString() === answer.toString()
            });
            return {
                questionId: questionId,
                optionId: answer,
                text: null,
                amount: null,
                questionMachineName: question.machineName,
                optionMachineName: option?option.machineName:null
            }
        }
        if(question.inputType === 'calendar'){
            return {
                questionId: questionId,
                optionId: null,
                text: null,
                amount: null,
                date: moment(answer, 'DD/MM/YYYY').format(),
                questionMachineName: question.machineName
            }
        }
    };

    _handleHoldCoverSubmit = (evt) => {
      evt.preventDefault();
      if(!this.props.agreeToHoldCover){
          this.props.changeQuoteState({
              key: 'errorMessage',
              value: 'Please, agree to proceed.'
          });
          return;
      }
      if(!this.props.quoteRequired){
          this.props.changeQuoteState({
              key: 'errorMessage',
              value: 'Please, select quote required.'
          });
          return;
      }
        this.props.updateQuote({
            sendBody: {
                id: this.props.quote.id,
                statusMachineName: 'HoldCover',
                termsAgreed: this.props.agreeToHoldCover,
                clientAddress: this.props.clientAddress,
                selectedProductId: this.props.quoteRequired,
                coverStartDate: moment(this.props.coverStartDate, 'DD/MM/YYYY').format()
            }
        })
    };

    _handleQuoteCompleteSubmit = () => {
        this.props.updateQuote({
            sendBody: {
                id: this.props.quote.id,
                statusMachineName: 'ViewQuotes',
            }
        })
    };

    _handleQuoteOptionsSubmit = (evt) => {
        evt.preventDefault();
        this.props.updateQuote({
            sendBody: {
                id: this.props.quote.id,
                statusMachineName: 'QuoteDetails',
                chosenProducts: _.map(this.props.products, product => {
                    const productInfo = this._getQuoteProductInfo(product.masterProductId);
                    const selectedCommercialRate = product.commercialRates.find(rate => {
                        return (
                            (rate.limitOfIndemnity.toString() === product.limitOfIndemnity) &&
                            (rate.masterProductId.toString() === product.masterProductId.toString())
                        )
                    })
                    return {
                        quoteApplicationId: this.props.quote.id,
                        masterProductId: parseInt(product.masterProductId),
                        limitOfIndemnity: parseInt(product.limitOfIndemnity),
                        tid: selectedCommercialRate.tid,
                        wid: selectedCommercialRate.wid,
                        agentCommission: parseFloat(this.props.agentCommission),
                        automaticCover: productInfo.automaticCover,
                        cdRecovery: productInfo.contractAndDept,
                        premium: productInfo.premium,
                        totalPremium: productInfo.totalPremium,
                    }
                })
            }
        })
    };

    _getQuoteProductInfo = (quotation) => {
        const products = this.props ? this.props.products : this.products;
        const mininum = this.props.minimumPricing.find( m => m.policyType == `${ARAG_POLICY_TYPE}`);
        const limitOfIndemnity = products[quotation].limitOfIndemnity;
        const annualTurnover = this._getQuestionAnswer('AnnualTurnover');
        const annualWageRoll = this._getQuestionAnswer('AnnualWageroll');
        try {
            const product =  this.props ? _.find(this.props.quote.availableProducts, p => {
                return (
                    (p.limitOfIndemnity.toString() === limitOfIndemnity.toString()) &&
                    (p.masterProductId.toString() === quotation.toString())
                );
            }) :
              _.find(this.quote.availableProducts, p => {
                  return (
                    (p.limitOfIndemnity.toString() === limitOfIndemnity.toString()) &&
                    (p.masterProductId.toString() === quotation.toString())
                  );
              });
            var sliderAgentCommissionMultiplier = ((100 - product.agentCommission) / (100 - this.props.agentCommission));
            // product.wagerollPremium & product.turnoverPremium are per mill
            var automaticCoverGrossOfBudCommission = annualWageRoll * (product.wagerollPremium/1000.0);
            var cDRecoveryGrossOfBudCommission = annualTurnover?(
              annualTurnover * (product.turnoverPremium/1000.0)
            ): null;
            // check the mininum quote premium before broker's commission is applied
            if(automaticCoverGrossOfBudCommission < mininum.automaticCoverMinimum)
            {
                automaticCoverGrossOfBudCommission = mininum.automaticCoverMinimum
            }
            if(cDRecoveryGrossOfBudCommission && cDRecoveryGrossOfBudCommission < mininum.contractDebtMinimum)
            {
                cDRecoveryGrossOfBudCommission = mininum.contractDebtMinimum
            }
            var automaticCoverGrossOfQQCommission = automaticCoverGrossOfBudCommission * sliderAgentCommissionMultiplier;
            var cDRecoveryGrossOfQQCommission = cDRecoveryGrossOfBudCommission?(
              cDRecoveryGrossOfBudCommission * sliderAgentCommissionMultiplier
            ):null;
            const premium = (automaticCoverGrossOfQQCommission + (cDRecoveryGrossOfQQCommission?cDRecoveryGrossOfQQCommission:0));
            const ipt = {
                ...this.props.quoteIPT,
                value: premium * (this.props.quoteIPT.taxPercentage / 100)
            };

            return {
                masterProductId: quotation,
                automaticCover: automaticCoverGrossOfQQCommission,
                contractAndDept: cDRecoveryGrossOfQQCommission,
                premium: premium,
                ipt: ipt,
                totalPremium: premium + ipt.value,
            }
        } catch (e) {
            return {
                masterProductId: '',
                automaticCover: null,
                contractAndDept: null,
                premium: null,
                ipt: {},
                totalPremium: null,
            }
        }
    };

    _getQuoteMessageByPosition = (position) => {
      const message = _.find(this.props.quoteMessages, message => {return message.position === position});
      if(!message) return {};
      return message
    };

    _getQuoteStepTitle = () => {
        let position = '';
        if(this.props.wizardStep === 0) { position = 'QuickQuotePart1Title'}

        if(this.props.wizardStep === 1) { position = 'QuickQuotePart2Title'}

        if(this.props.wizardStep === 2) { position = ''}

        if(this.props.wizardStep === 3) { position = ''}

        if(this.props.wizardStep === 4) { position = ''}

        const message = this._getQuoteMessageByPosition(position);

        if(message){
            return message.body
        }

        return '';
    };

    _findQuoteAvailableProduct = (limitOfIndemnity, masterProductId) => {
        try {
            return _.find(this.props.quote.availableProducts, product => {
                return (
                    (product.masterProductId.toString() === masterProductId.toString()) &&
                    (product.limitOfIndemnity.toString() === limitOfIndemnity.toString())
                )
            })
        } catch (e) {
            return null;
        }
    };

    _findQuoteAdditionalInfo = (masterProductId) => {
        try {
            return this.props.quote.quoteAdditionalInfos.find(item => {
                return item.masterProductId === masterProductId;
            })
        } catch (e) {
            return null
        }

    };

    render(){
        return (
            <Quote
                {...this.props}
                _changeToNextStep={this._changeToNextStep}
                _changeToPreviousStep={this._changeToPreviousStep}
                handleSelectChange={this.handleSelectChange}
                _getQuestionAnswer={this._getQuestionAnswer}
                _handleClientDetailsFormSubmit={this._handleClientDetailsFormSubmit}
                _handleHoldCoverSubmit={this._handleHoldCoverSubmit}
                _handleQuoteCompleteSubmit={this._handleQuoteCompleteSubmit}
                _getQuoteProductInfo={this._getQuoteProductInfo}
                _handleQuoteOptionsSubmit={this._handleQuoteOptionsSubmit}
                _getQuoteMessageByPosition={this._getQuoteMessageByPosition}
                _getQuoteStepTitle={this._getQuoteStepTitle}
                _findQuoteAvailableProduct={this._findQuoteAvailableProduct}
                _findQuoteAdditionalInfo={this._findQuoteAdditionalInfo}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        wizardStep: state.quote.wizardStep,
        quoteQuestions: state.quote.quoteQuestions,
        quoteStatuses: state.quote.quoteStatuses,
        clientDetailsForm: state.quote.clientDetailsForm,
        agentCommission: state.quote.agentCommission,
        postingQuote: state.quote.posting,
        postQuoteFailedMessage: state.quote.postingErrorMessage,
        fetchingQuoteQuestions: state.quote.fetchingQuoteQuestions,
        agreeToHoldCover: state.quote.agreeToHoldCover,
        clientAddress: state.quote.clientAddress,
        coverStartDate: state.quote.coverStartDate,
        quoteRequired: state.quote.quoteRequired,
        loggedInUserId: state.user.loggedInUser.id,
        loggedInUserRoles: state.user.loggedInUser.roles,
        broker: state.broker.broker,
        errorMessage: state.quote.errorMessage,
        quote: state.quote.quote,
        minimumPricing: state.quote.minimumPricings,
        products: state.quote.products,
        updating: state.quote.updating,
        updateErrorMessage: state.quote.updateErrorMessage,
        quoteMessages: state.quote.quoteMessages,
        quoteIPT: state.quote.quoteIPT,
        quotePolicyOverview: state.quote.quotePolicyOverview,
        fetchingQuote: state.quote.fetchingQuote,
        quoteScheduleMessage: state.quote.quoteScheduleMessage,
        selectedBroker: state.quote.broker,
        brokers: state.brokers.brokers,
        quoteProposalForm: state.quote.quoteProposalForm,
        fetchingQuoteProposalForm: state.quote.fetchingQuoteProposalForm,
        quotePolicyWording: state.quote.quotePolicyWording,
        fetchingQuotePolicyWording: state.quote.fetchingQuotePolicyWording,
        quotePointOfSale: state.quote.quotePointOfSale,
        fetchingQuotePointOfSale: state.quote.fetchingQuotePointOfSale,
        sendingQuoteScheduleViaEmail: state.quote.sendingQuoteScheduleViaEmail,
        sendEmailSuccessResponse: state.quote.sendEmailSuccessResponse,
        sendEmailFailResponse: state.quote.sendEmailFailResponse
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeQuoteState: (payload) => {
            dispatch(changeQuoteState(payload))
        },
        getQuoteQuestions: (payload) => {
            dispatch(getQuoteQuestions(payload))
        },
        getQuoteStatuses: (payload) => {
            dispatch(getQuoteStatuses(payload))
        },
        changeQuoteClientDetailsForm: (payload) => {
            dispatch(changeQuoteClientDetailsForm(payload))
        },
        createQuote: (payload) => {
            dispatch(createQuote(payload))
        },
        changeBrokerCommission: (payload) => {
            dispatch(changeBrokerCommission(payload))
        },
        getScheduleFooter: (payload) => {
            dispatch(getScheduleFooter(payload))
        },
        changeQuoteRequired: (payload) => {
            dispatch(changeQuoteRequired(payload))
        },
        getBrokerById: (payload) => {
            dispatch(getBrokerById(payload))
        },
        handleQuoteProductsChange: (payload) => {
            dispatch(handleQuoteProductsChange(payload))
        },
        updateQuote: (payload) => {
            dispatch(updateQuote(payload))
        },
        getQuoteIPT: (payload) => {
            dispatch(getQuoteIPT(payload))
        },
        getQuoteDefaultSettings: (payload) => {
            dispatch(getQuoteDefaultSettings(payload))
        },
        getQuoteMessages: (payload) => {
            dispatch(getQuoteMessages(payload))
        },
        copyQuote: (payload) => {
            dispatch(copyQuote(payload))
        },
        getQuotePolicyOverview: (payload) => {
            dispatch(getQuotePolicyOverview(payload))
        },
        getQuoteById: (payload) => {
            dispatch(getQuoteById(payload))
        },
        resetQuoteOptions: (payload) => {
            dispatch(resetQuoteOptions(payload))
        },
        getQuoteSchedulesMessage: (payload) => {
            dispatch(getQuoteSchedulesMessage(payload))
        },
        resetQuoteState: (payload) => {
            dispatch(resetQuoteState(payload))
        },
        getBrokers: (payload) => {
            dispatch(getBrokers(payload))
        },
        sendQuoteScheduleViaEmail: (payload) => {
            dispatch(sendQuoteScheduleViaEmail(payload))
        },
        getQuoteProposalForms: (payload) => {
            dispatch(getQuoteProposalForms(payload))
        },
        getQuotePolicyWordings: (payload) => {
            dispatch(getQuotePolicyWordings(payload))
        },
        getQuotePointsOfSale: (payload) => {
            dispatch(getQuotePointsOfSale(payload))
        },
        getQuoteScheduleInfo: (payload) => {
            dispatch(getQuoteScheduleInfo(payload))
        },
        getQuoteMinimumPricing: (payload) => {
            dispatch(getQuoteMinimumPricing(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(QuoteHOC)
